import styles from "./Header.module.scss";

export const Header = () => {
    return (
        <div className={styles.header}>
            <div className={styles.title}>Dr. Oleg Torsunov </div>
            <div className={styles.menu}>
                <div className={styles.menuElement}>
                    VIP Personal Consultation 
                </div>
                <div className={styles.menuElement}>
                    Psychophysical Constitution Assessment 
                </div>
                <div className={styles.menuElement}>health guide</div>
            </div>
        </div>
    );
};
